export class NetUtil {
    public static getQueryStringValue (key:string):string {  
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));  
      } 
}


// WEBPACK FOOTER //
// ./src/framework/utils/NetUtil.ts